import { WalletClient } from '#/features/wallet/common/wallet-client';

export async function requestDepositLayerswap(
  walletClient: WalletClient,
  calldata: string,
) {
  return walletClient.sendTransaction(calldata);
}
